import { render } from "./DbLookupForm.vue?vue&type=template&id=1ccd331e&ts=true"
import script from "./DbLookupForm.vue?vue&type=script&lang=ts"
export * from "./DbLookupForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__